import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['hauptbild', 'thumbnail', 'modalBild']

  select(event) {
    const thumbnail = event.currentTarget
    const url = thumbnail.dataset.bildUrl
    this.hauptbildTarget.src = url
    if (this.hasModalBildTarget) this.modalBildTarget.src = url
    this.thumbnailTargets.forEach(t => t.classList.remove('tack-artikel-thumbnail--active'))
    thumbnail.classList.add('tack-artikel-thumbnail--active')
  }
}
